import { Grid, Typography } from '@mui/material';

import { TipoUsuario } from 'src/models/Usuario';
import { abreviarNome } from 'src/shared/functions/abreviarNome';

import Card from '../../../assets/embarque-ja-card.svg';
import { Carteira as CarteiraModel } from '../../../models/Carteira.model';
import { Colors } from '../../../shared/colors';
import Currency from '../Currency';

import NumeroCartao from './NumeroCartao';

interface PropsCartao {
  carteira: CarteiraModel;
}

const Cartao = ({ carteira }: PropsCartao) => {
  return (
    <Grid
      sx={{
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        aspectRatio: '16/9',
        backgroundImage: `url(${Card})`
      }}
      container
      maxWidth={450}
      bgcolor="secondary.main"
      position="relative"
      borderRadius={1}
    >
      <Grid pr={2} item container display="flex" justifyContent="space-between" mt={2}>
        <Grid display="flex" item alignItems="center" ml={{ xs: 6.5, sm: 8 }} mt={{ xs: 3, sm: 4 }}>
          <Typography color={Colors.white} variant="body2">
            {carteira.tipoCarteira === TipoUsuario.PESSOA_FISICA
              ? 'Pessoa física'
              : 'Pessoa jurídica'}
          </Typography>
        </Grid>
        <Grid item mt={{ sm: 1 }}>
          <Typography
            color={Colors.white}
            variant="h5"
            fontSize={{ xs: '1.125rem', sm: '1.375rem' }}
            fontWeight="bold"
          >
            <Currency value={carteira.saldo} />
          </Typography>
        </Grid>
      </Grid>

      <Grid container flexDirection="column" mt={{ xs: 1.5, sm: 1.5 }} ml={{ xs: 2.5, sm: 3 }}>
        <Grid item>
          <Typography
            color={Colors.white}
            variant="h5"
            fontSize={{ xs: '1rem', sm: '1.2rem', lg: '1.4rem' }}
            fontWeight="bold"
          >
            {abreviarNome(carteira.nomeUsuario)}
          </Typography>
        </Grid>

        <Grid
          item
          sx={{
            visibility: TipoUsuario.PESSOA_JURIDICA && carteira.nomeSetor ? 'visible' : 'hidden'
          }}
        >
          <Typography
            color={Colors.white}
            variant="body2"
            fontSize={{ xs: '0.7rem', sm: '0.7rem', lg: '0.8rem' }}
          >
            ID/Setor: {carteira.idSetor ? `${carteira.idSetor} - ` : ''} {carteira.nomeSetor}
          </Typography>
        </Grid>
      </Grid>

      <Grid container display="flex" flexDirection="column" alignItems="flex-end">
        <Grid item xs={3.5} display="flex" flexDirection="column">
          <Grid item sx={{ visibility: carteira.numeroCartaoFisico ? 'visible' : 'hidden' }}>
            <NumeroCartao tipo="Cartão Físico" numero={carteira.numeroCartaoFisico} />
          </Grid>

          <Grid item mt={1}>
            {Boolean(carteira.numeroCartaoVirtual) && (
              <NumeroCartao tipo="Cartão Digital" numero={carteira.numeroCartaoVirtual} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Cartao;
